import React, { JSX } from 'react';
import { ImageField } from '@sitecore-jss/sitecore-jss-nextjs';
import { StyleguideComponentProps } from 'lib/component-props';
import { classNames } from 'assets/utils/helper';
import { getMarginSize } from 'assets/utils/getMarginSize';

type BannerProps = StyleguideComponentProps & {
  fields: {
    MarginSize: {
      fields: {
        heading: {
          value: string;
        };
      };
    };
    image_lg: ImageField;
    image_sm: ImageField;
  };
};

const Banner = (props: BannerProps): JSX.Element => {
  if (!props || !props.fields) {
    return <div></div>;
  }
  const marginSize = getMarginSize(
    props?.fields?.MarginSize?.fields?.heading?.value
  );
  return (
    <div
      className={classNames('banner', marginSize)}
      id={`banner-${props.rendering?.uid}`}
    >
      <picture className="banner-img">
        {props.fields.image_lg && (
          <source
            media="(min-width: 1280px)"
            srcSet={props.fields.image_lg.value?.src}
          />
        )}
        {props.fields.image_sm && (
          <img src={props.fields.image_sm.value?.src} alt="banner" />
        )}
      </picture>
    </div>
  );
};

export default Banner;
